import React, { useState } from 'react';
import { useLens } from './LensProvider';

const stabilityLabel = (pressure) => {
  if (pressure < 0.2) return { label: 'Stable', color: 'var(--success)' };
  if (pressure < 0.5) return { label: 'Moderate', color: 'var(--accent)' };
  if (pressure < 0.8) return { label: 'Strained', color: 'var(--warning)' };
  return { label: 'Overloaded', color: 'var(--danger)' };
};

const headlineColor = (pressure) => {
  if (pressure < 0.2) return 'var(--success)';
  if (pressure < 0.5) return 'var(--accent)';
  if (pressure < 0.8) return 'var(--warning)';
  return 'var(--danger)';
};

export const ExperiencePanel = () => {
  const { pressure, alignment, phenomenology, explanation, shareUrl } = useLens();
  const stability = stabilityLabel(pressure);
  const [copied, setCopied] = useState(false);

  const handleShare = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="experience-panel">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
        <h2>Experience</h2>
        <button
          onClick={handleShare}
          style={{
            background: 'transparent',
            border: '1px solid var(--border)',
            color: copied ? 'var(--success)' : 'var(--text-dim)',
            fontSize: '0.7rem',
            padding: '4px 10px',
            borderRadius: '4px',
            cursor: 'pointer',
            transition: 'all 0.2s',
          }}
        >
          {copied ? 'Copied!' : 'Share this aperture'}
        </button>
      </div>

      {phenomenology.headline && (
        <div style={{
          fontSize: '1.8rem',
          fontWeight: 300,
          letterSpacing: '0.08em',
          color: headlineColor(pressure),
          margin: '4px 0 12px',
        }}>
          {phenomenology.headline}
        </div>
      )}

      <div style={{ display: 'flex', gap: '24px', marginBottom: '8px', fontSize: '0.8rem' }}>
        <span>
          Pressure: <strong style={{ color: stability.color }}>{pressure.toFixed(2)}</strong>
        </span>
        <span>
          Alignment: <strong>{alignment.toFixed(2)}</strong>
        </span>
        <span style={{ color: stability.color }}>
          {stability.label}
        </span>
      </div>
      {phenomenology.analogy && (
        <p style={{
          fontSize: '0.8rem',
          color: 'var(--text-dim)',
          fontStyle: 'italic',
          margin: '0 0 12px',
          borderLeft: '2px solid var(--border)',
          paddingLeft: '10px',
        }}>
          {phenomenology.analogy}
        </p>
      )}
      <p style={{ lineHeight: '1.8', margin: 0 }}>{explanation}</p>
    </div>
  );
};
